import { TriangleAlert, X } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface ChatSendErrorBannerProps {
  message: string
  unsentMessage: string
  onDismiss: () => void
}

export function ChatSendErrorBanner({ message, unsentMessage, onDismiss }: Readonly<ChatSendErrorBannerProps>) {
  return (
    <div className="py-3" role="alert" data-testid="chat-send-error-banner">
      <div className="mx-auto max-w-2xl rounded-md border border-warning-foreground bg-warning px-4 py-3">
        <div className="flex items-start gap-2">
          <TriangleAlert className="h-4 w-4 text-warning-foreground shrink-0 mt-0.5" aria-hidden />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold text-warning-foreground">Message not sent</p>
            <p className="text-sm text-warning-foreground break-words">{message}</p>
            {unsentMessage && (
              <p
                className="mt-2 max-h-24 overflow-y-auto whitespace-pre-wrap break-words text-xs text-muted-foreground"
                data-testid="chat-send-error-unsent-message"
              >
                {unsentMessage}
              </p>
            )}
          </div>
          <Button
            type="button"
            variant="ghost"
            size="iconSm"
            className="-mr-2 -mt-1.5 shrink-0 text-warning-foreground"
            aria-label="Dismiss error"
            onClick={onDismiss}
          >
            <X className="h-4 w-4" aria-hidden />
          </Button>
        </div>
      </div>
    </div>
  )
}
